<template lang="pug">
.member-icon-text(@click="$emit('clicked')")
  member-icon(:grade="grade")
  .copy {{$t(`grade.${grade}`)}}
</template>
<script>
import MemberIcon from '@/components/wedgits/MemberIcon'
export default {
  name: 'MemberIconText',
  components: { MemberIcon },
  props: {
    grade: {},
    price: {},
  },
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.member-icon-text
  height: pxToRem(60)
  border-radius: pxToRem(30)
  line-height: pxToRem(60)
  background: white
  //padding: 0 pxToRem(24)
  +flex-center
  flex-direction: row
  .copy
    color: black
    font-size: pxToRem(30)
</style>
